import { movieService } from '@services/index';
import { useMutation } from '@tanstack/react-query';

export default function useMutationDeleteMovie() {
	return useMutation({
		mutationFn: ({ movieId }: { movieId: number }) => movieService.deleteMovie(movieId)
	});
}
